// Веб-вклад модуля `course-templates` — ЕДИНЫЙ каталог курсов.
//
// Пункта навигации НЕТ сознательно: вход в каталог — кнопка в шапке раздела
// «Обучение», отдельным разделом он не является (гостю каталог показывается
// пунктом `GUEST_NAV`, но это поверхность, а не вклад модуля). Манифест нужен
// ради роутов: без него `/catalog` не имеет владельца, и гейт «роут ↔ модуль»
// не сможет отличить его от потерянного маршрута.
//
// `/catalog` и `/catalog/$slug` — публичная витрина (список + карточка курса по
// slug). Она вынесена ЗА закрытый префикс `/courses`, см. `lib/protected-routes.ts`.
// Карточка объявляется отдельной строкой, а не подразумевается префиксом: гейт
// «роут ↔ модуль» сверяет ПОЛНЫЕ пути, и `/catalog/$slug` без записи выглядит
// для него потерянным маршрутом.
//
// Легаси-URL (`/courses/catalog`, `/courses/templates`, `/study-plan/templates`)
// остаются в списке: они живы редиректами на каталог, а роут без владельца гейт
// не пропустит.

import { SECTION_ICONS } from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const courseTemplatesWebManifest = {
	id: "course-templates",
	icon: SECTION_ICONS.course,
	labelKey: "nav.courses",
	routes: [
		"/catalog",
		"/catalog/$slug",
		"/courses/catalog",
		"/courses/templates",
		"/study-plan/templates",
	],

	// Баннер РАЗГРАНИЧИВАЕТ каталог с разделом «Курсы» и снимает два ложных
	// ожидания разом: материалы автора НЕ переносятся, и новая версия курса не
	// применяется сама. Ключи лежат в словаре `courses` под своим префиксом —
	// namespace у каталога и у курсов один, а тексты разные.
	intro: {
		titleKey: "courses:catalogIntro.title",
		bodyKey: "courses:catalogIntro.body",
		bulletKeys: [
			"courses:catalogIntro.bullets.0",
			"courses:catalogIntro.bullets.1",
			"courses:catalogIntro.bullets.2",
		],
	},
} satisfies WebModuleManifest;
